/* ============================================================
   O66Y - QUICK ADD BOTTOM SHEET
   Populates itself by cloning nodes already rendered inside the
   clicked .product-card (image, title, price, badges, variant
   buttons) — no duplicate data pipeline from Liquid.
   ============================================================ */

'use strict';

const initQuickAddSheet = () => {
  const overlay = document.getElementById('QuickAddOverlay');
  const sheet = document.getElementById('QuickAddSheet');
  if (!overlay || !sheet) return;

  const mediaEl = document.getElementById('QuickAddMedia');
  const badgesEl = document.getElementById('QuickAddBadges');
  const titleEl = document.getElementById('QuickAddProductTitle');
  const priceEl = document.getElementById('QuickAddPrice');
  const sizesEl = document.getElementById('QuickAddSizes');
  const sizeErrorEl = document.getElementById('QuickAddSizeError');
  const atcBtn = document.getElementById('QuickAddAtc');
  const buyNowBtn = document.getElementById('QuickAddBuyNow');
  const closeBtn = document.getElementById('QuickAddClose');

  let selectedVariantId = null;

  function open() {
    overlay.classList.add('active');
    sheet.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('active');
    sheet.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function resetButtons() {
    [atcBtn, buyNowBtn].forEach((b) => {
      b.classList.remove('loading');
      b.disabled = false;
    });
  }

  function updateCartBadge() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const badge = document.querySelector('.navbar__cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('visible', cart.item_count > 0);
        }
      });
  }

  function populate(card) {
    const img = card.querySelector('.product-card__slide img, .product-card__img-placeholder');
    mediaEl.innerHTML = '';
    if (img) mediaEl.appendChild(img.cloneNode(true));

    const badges = card.querySelector('.product-card__badges');
    badgesEl.innerHTML = badges ? badges.innerHTML : '';

    const titleLink = card.querySelector('.product-card__title-link');
    titleEl.textContent = titleLink ? titleLink.textContent.trim() : '';

    const price = card.querySelector('.product-price');
    priceEl.innerHTML = price ? price.innerHTML : '';

    const template = card.querySelector('.product-card__quick-add-variants');
    sizesEl.innerHTML = '';
    selectedVariantId = null;
    sizeErrorEl.classList.remove('visible');
    if (template) {
      sizesEl.appendChild(template.content.cloneNode(true));
    }

    resetButtons();
  }

  function addToCart(goToCheckout) {
    if (!selectedVariantId) {
      sizeErrorEl.classList.add('visible');
      return;
    }

    const btn = goToCheckout ? buyNowBtn : atcBtn;
    btn.classList.add('loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(() => {
        if (goToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        close();
        resetButtons();
        updateCartBadge();
        if (window.O66YCart) {
          window.O66YCart.refresh();
          setTimeout(() => window.O66YCart.open(), 300);
        }
      })
      .catch(() => {
        resetButtons();
      });
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.product-card__quick-add-btn');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      const card = trigger.closest('.product-card');
      if (card) {
        populate(card);
        open();
      }
      return;
    }

    const sizeBtn = e.target.closest('#QuickAddSizes button[data-variant-id]');
    if (sizeBtn) {
      e.preventDefault();
      if (sizeBtn.disabled) return;
      sizesEl.querySelectorAll('button').forEach((b) => b.classList.remove('active'));
      sizeBtn.classList.add('active');
      selectedVariantId = sizeBtn.dataset.variantId;
      sizeErrorEl.classList.remove('visible');
      return;
    }
  });

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  atcBtn.addEventListener('click', () => addToCart(false));
  buyNowBtn.addEventListener('click', () => addToCart(true));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet.classList.contains('active')) close();
  });
};

document.addEventListener('DOMContentLoaded', initQuickAddSheet);
